/**
 * Created by yangxx on 2017/10/21.
 * 自定义overlay拖拽组件
 */
/**
 * 自定义overlay拖拽组件
 * @module PlotOverlayTool
 */
'use strict';
define([
    '../base/PureComponent',
    '../utils/CommonUtil',
    '../g2'
], function (PureComponent,
    CommonUtil,
    g2) {
    var component = PureComponent.extend({
        options: {
            collision: 'visibility',
            //线符号
            symbol: {
                type: 'SimpleLineSymbol',
                options: {
                    "color": {
                        "a": 250,
                        "r": 0,
                        "g": 0,
                        "b": 0
                    },
                    "style": 5,
                    "width": 2
                }
            }
        },
        domMoveList: [],
        _domMoveStart: {},
        initialize: function (options) {
            PureComponent.prototype.initialize.call(this, options);
            try {
                this.overlayWare = new g2.widget.OverlayWare3D({ map: { map: this.map } });
                // this.addListeners();
            } catch (e) { }

            window.test = this;

        },
        clear: function () {
            this.removeAll();
        },
        destroy: function () {
            //ol drag
            try {
                this.removeListeners();
            } catch (e) { }
            PureComponent.prototype.destroy.call(this);
        }
    });
    /**
     * 内部方法
     */
    component.include({
        _parseDom: function (elementStr) {
            var div = document.createElement("div");
            div.innerHTML = elementStr;
            return div.childNodes[0];
        },
        addListeners: function () {
            this.onmousemove = (button, shift, screenX, screenY, mapX, mapY, handle) => {
                const e = {
                    screenX, screenY, mapX, mapY,
                }
                this._domMoveMapMove(e);
            }
            this.onmouseup = (button, shift, screenX, screenY, mapX, mapY, handle) => {
                // this._moveDomEnd();
                this._domMove = false;
            }
            this.map.on('mousemove', this.onmousemove);
            this.map.on('mouseup', this.onmouseup);
        },
        removeListeners: function () {
            this.map.un('mousemove', this.onmousemove);
            this.map.un('mouseup', this.onmouseup);
        },
        //监听事件
        _bindDomEvent: function (opts, overlay) {
            const self = this;
            const container = document.getElementById(opts.id);
            container.onmousedown = _moveDomStart.bind(this);
            container.onmouseup = _moveDomEnd.bind(this);
            container.onclick = _clickDom.bind(this);
            const domMoveObj = {
                id: opts.id,
                kind: 'overlay',
                opts,
                container,
                overlay,
                tag: opts.tag,
            };
            this.domMoveList.push(domMoveObj);
            self.fire('updateOverlayPlot', domMoveObj);
            function _moveDomStart(e) {
                var ele = e.currentTarget;
                if (!!ele) {
                    this.addListeners();
                    console.debug('开始 > 地图停止拖拽');
                    self._domMove = true;
                    e.preventDefault();
                    self.map.stopDragPan();
                    self.domMoveObj = domMoveObj;
                    self.mousedownTime = new Date().getTime();
                }
            }
            function _moveDomEnd(e) {
                this.removeListeners();
                if (self._domMove) {
                    console.debug('停止>地图恢复拖拽');
                    self._domMove = false;
                    self.mouseUpTime = new Date().getTime();
                    self.map.resumeDragPan();
                    self.fire('updateOverlayPlot', domMoveObj);
                }
            }
            function _clickDom() {
                this.fire('overlayClick', this.domMoveObj);
            }
        },
        _domMoveMapMove: function (e) {
            if (this._domMove) {
                const point = this.map.pickSurfacePosition({x:e.screenX, y:e.screenY});
                this.domMoveObj.overlay.position = point;
                this.overlayWare.update(this.domMoveObj.overlay);
               
            }
            // 地图鼠标事件时，禁用拖拽也可以解决拖拽地图动的问题
            // this.map.stopDragPan();
        },
        _moveDomEnd: function () {
            console.debug('停止');
            this.removeListeners();
            if (this._domMove) {
                this._domMove = false;
                this.mouseUpTime = new Date().getTime();
                this.map.resumeDragPan();
                this.fire('updateOverlayPlot', this.domMoveObj);
                // this.map.resumeDragPan();
            }
        },
        _clickDom: function () {
            if ((this.mouseUpTime - this.mousedownTime) < 200) {
                this.fire('overlayClick')
            }
        }
    });

    /**
     * 对外接口
     */
    component.include({
        /**
         * 添加
         * @method
         */
        add: async function (opts) {
            let content = '<div id="' + opts.id + '" ';
            let offsetY = 0;
            if (opts.options.width && opts.options.height) {
                content += 'style="width:' + opts.options.width + 'px;height:' + opts.options.height + 'px;"';
                offsetY = opts.options.height/2;
            } else {
                content += 'style="width:60px;height:60px;"';
                offsetY = 30;
            }
            content += ' class="plot-overlay-div">';
            switch (opts.options.type) {
                case 'iframe':
                    content += '<iframe src="' + opts.options.source + '" style="border: 0px; width: 100%; height: 100%; pointer-events: none;"></iframe>';
                    break;
                case 'image':
                    content += '<img src="' + opts.options.source + '" style="pointer-events: none;"/>';
                    content += '</div>';
                    break;
                case 'html':
                    content += opts.options.source;
                    content += '</div>';
                    break;
            }
            let z = opts.point.z;
            if (!z) {
                z = await this.getAltitude([opts.point.x, opts.point.y]);
            }
            const position = new g2.sfs.Point({
                x: opts.point.x,
                y: opts.point.y,
                z,
                spatialReference: this.map.getSrid() || 4326,
            })
            var overlay = new g2.widget.OverLay({
                id: opts.id || CommonUtil.newUUID32(),
                element: this._parseDom(content),//DOM元素
                offset: [0, -offsetY],//覆盖物相对位置的偏移量
                position, //覆盖物位置
                positioning: "center-center",//覆盖物相对于坐标点的位置
                stopEvent: true //在地图覆盖物上是否禁用地图事件
            });
            this.overlayWare.add(overlay);  //添加覆盖物
            // 对dom添加移动的事件
            this._bindDomEvent(opts, overlay);

        },
        /**
         * 根据id获取overlay Object
         * @param {*} id 
         */
        getOverlayObjById: function (id) {
            let obj = null;
            for (var i = 0; i < this.domMoveList.length; i++) {
                if (this.domMoveList[i].opts.id === id) {
                    obj = this.domMoveList[i];
                }
            }
            return obj;
        },
        /**
         * 控制显隐
         * @param {*} id 
         * @param {*} visible 
         */
        showElement: function (id, visible) {
            const obj = this.getOverlayObjById(id);
            obj.container.style.display = visible? 'block' : 'none'; 
        },
        /**
         * 序列化overlayObj
         * @param {*} obj 
         */
        serialize: function (obj) {
            const point = obj.overlay.position;
            obj.opts.point = point;
            return JSON.stringify(obj.opts);
        },
        getAltitude(point) {
            return new Promise((resolve, reject) => {
                const position = new g2.sfs.Point({
                    x: point[0],
                    y: point[1],
                    z: 0,
                    spatialReference: this.map.getSrid(),
                });
                this.map.getAltitude([position]).then((points) => {
                    const pos = points[0];
                    resolve(parseFloat(pos.z.toFixed(2)));
                });
            });
        },
        // /**
        //  * 更新
        //  * @method
        //  * @memberOf G.components.TailedLabelComponent.prototype
        //  * @param id {String} 必填，要更新的引线标注id
        //  * @param label {String} 必填，更新的文本内容
        //  * @param opts {Object} 可选，更新文本的配置
        //  * @returns {Boolean}
        //  */
        // update: function (id, label, opts) {

        // },
        /**
         * 移除
         * @method
         * @memberOf G.components.TailedLabelComponent.prototype
         * @param id {String} 必填，要移除的引线标注id
         * @returns {Boolean}
         */
        remove: function (id) {
            const container = document.getElementById(id);
            if (container) {
                container.onmousedown = null;
                container.onmouseup = null;
                container.onclick = null;
            }

            this.overlayWare.remove(id);
            for (var i = this.domMoveList.length - 1; i >= 0; i--) {
                if (this.domMoveList[i].id === id) {
                    this.domMoveList.splice(i, 1)
                }
            }
        },

        /**
         * 移除所有
         * @method
         * @memberOf G.components.TailedLabelComponent.prototype
         */
        removeAll: function () {
            for (var i = this.domMoveList.length - 1; i >= 0; i--) {
                const container = document.getElementById(this.domMoveList[i].id);
                container.onmousedown = null;
                container.onmouseup = null;
                container.onclick = null;
            }
            this.domMoveList = []
            this.overlayWare.clear();

        },
    });
    return component;
});